import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function Hero() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-6 py-20 z-10 overflow-hidden" data-id="element-97">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-night-900/50 via-night-900 to-night-900 pointer-events-none" data-id="element-98" />

      <div ref={ref} className={`relative max-w-4xl mx-auto text-center flex flex-col items-center section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-99">
        {/* Moon Visual */}
        <div className="mb-12 relative animate-float" data-id="element-100">
          <div className="w-24 h-24 md:w-32 md:h-32 moon-crescent opacity-90" data-id="element-101" />
          <div className="absolute inset-0 bg-gold-500/20 blur-2xl rounded-full" data-id="element-102" />
        </div>

        {/* Headlines */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-cream-100 leading-tight mb-6 tracking-wide" data-id="element-103">
          Cómo Silenciar Tu Mente y Recuperar el Sueño Profundo en Solo 10
          Minutos
        </h1>

        <p className="text-lg md:text-xl text-gold-400 italic mb-8 font-body" data-id="element-104">
          (Sin Pastillas ni Efectos Secundarios)
        </p>

        <h2 className="text-xl md:text-2xl text-cream-200 font-heading mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-105">
          El Método S.C.A.: Diseñado específicamente para mujeres de 50+ que
          están cansadas de que su cama sea un campo de batalla contra sus
          propios pensamientos.
        </h2>

        {/* Opening Hook */}
        <div className="max-w-2xl mx-auto text-left space-y-6 text-lg md:text-xl text-cream-200/90 leading-relaxed border-l-2 border-gold-500/30 pl-6 py-2" data-id="element-106">
          <p data-id="element-107">
            Son las <span className="text-gold-400 font-semibold" data-id="element-108">2:00 AM</span>
            . Estás agotada, tus ojos pesan, pero tu mente está corriendo un
            maratón. Repasas lo que pasó hoy, lo que tienes que hacer mañana y
            esos miedos que solo aparecen en la oscuridad.
          </p>
          <p className="italic text-cream-100" data-id="element-109">
            Te sientes eléctrica, frustrada y profundamente sola mientras el
            resto del mundo duerme. Sabes que mañana será otro día de neblina
            mental y falta de energía.
          </p>
        </div>

        {/* CTA Button */}
        <a href="#oferta" className="mt-14 inline-block bg-gold-500 hover:bg-gold-400 text-night-900 font-bold text-lg md:text-xl py-5 px-10 rounded-full transition-all duration-300 transform hover:scale-105 animate-glow-pulse shadow-xl text-center no-underline" aria-label="Ver oferta y comprar" data-id="element-110">
          ¡SÍ, QUIERO DORMIR EN PAZ!
          <span className="block text-sm font-medium opacity-80 mt-1" data-id="element-111">
            DESCARGAR AHORA
          </span>
        </a>
      </div>
    </section>;
}